module.exports = __webpack_public_path__ + "img/pass_type_Bundle.eaaae940.jpg";